/**
*  @class
*  @function FullMenu
*/
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.buttons = this.querySelectorAll('.full-menu--link-parent');
      this.header = this.closest('.header');
      this.subButtons = this.querySelectorAll('.full-menu--link-child');
      this.panel = this.querySelector('.full-menu--panel');
      this.panel1 = this.querySelector('.full-menu--panel--level-1');
      this.cc = this.querySelector('.full-menu--cc');
      this.toggle = this.querySelector('.full-menu--toggle');
      if (window.innerWidth < 1440) {
        this.panelWidth = 320;
        this.panelWidthTotal = (this.panelWidth * 3.496875) + 80;
      } else {
        this.panelWidth = 400;
        this.panelWidthTotal = (this.panelWidth * 3.40) + 80;
      }
      this.rtl = document.dir === 'rtl';
    }
    connectedCallback() {
      this.buttons.forEach((button, i) => {
        button.addEventListener('mouseenter', (e) => this.onParentHover(button, e, i));
        button.addEventListener('keydown', (e) => this.onParentKeydown(button, e, i));
        button.addEventListener('focus', (e) => this.onParentFocus(button, e, i));
      });
      this.subButtons.forEach((button, i) => {
        button.addEventListener('mouseenter', (e) => this.onChildHover(button, e, i));
      });
      this.toggle.addEventListener('click', this.onToggleClick.bind(this));
      // this.cc.addEventListener('mousemove', this.onCC.bind(this));
      this.panel.style.setProperty('--menu-panel-width-total', this.panelWidthTotal + 'px');

      // this.addEventListener('blur', this.onCC.bind(this));
      document.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') {
          this.onCC();
        }
      });
      window.addEventListener('resize', () => {
        if (window.innerWidth < 1440) {
          this.panelWidth = 320;
          this.panelWidthTotal = (this.panelWidth * 3.496875) + 80;
        } else {
          this.panelWidth = 400;
          this.panelWidthTotal = (this.panelWidth * 3.40) + 80;
        }
        this.panel.style.setProperty('--menu-panel-width-total', this.panelWidthTotal + 'px');
        if (document.querySelector('theme-header').classList.contains('open-menu') && document.querySelector('theme-header .full-menu--subpanel.active')) {
          this.panel.style.setProperty('--menu-panel-width', this.panelWidthTotal + 'px');
        }
      });
    }
    onParentFocus() {
      this.header.classList.add('open-menu');
    }
    onParentKeydown(button, e, i) {
      if (e.code.toUpperCase() !== 'ENTER') return;

      if (button.classList.contains('has-sub-menu')) {
        let submenus = this.panel1.querySelectorAll('.full-menu--subpanel'),
          target_selector = button.dataset.target;
        this.panel.style.setProperty('--menu-panel-width', this.panelWidthTotal + 'px');

        [].forEach.call(submenus, function (el) {
          el.classList.remove('active');
        });
        this.panel1.querySelector(target_selector).classList.add('active');
        this.panel1.querySelector(target_selector).querySelectorAll('a')[0].focus();
      }
    }
    onParentHover(button, e, i) {
      this.header.classList.add('open-menu');

      if (button.classList.contains('has-sub-menu')) {
        let submenus = this.panel1.querySelectorAll('.full-menu--subpanel'),
          target_selector = button.dataset.target;
        this.panel.style.setProperty('--menu-panel-width', this.panelWidthTotal + 'px');

        [].forEach.call(submenus, function (el) {
          el.classList.remove('active');
        });
        this.panel1.querySelector(target_selector).classList.add('active');
      } else {
        this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 1) + 'px');
      }
      window.dispatchEvent(new Event('resize'));
      e.preventDefault();
    }
    onChildHover(button, e, i) {
      if (button.classList.contains('has-sub-menu')) {
      } else {
        this.panel.style.setProperty('--menu-panel-width', this.panelWidthTotal + 'px');
      }

      e.preventDefault();
    }
    onPanelLeave() {
      this.panel.style.setProperty('--menu-panel-width', this.panelWidthTotal + 'px');
    }
    onToggleClick() {
      this.header.classList.add('open-menu');
    }
    onCC() {
      this.panel.style.setProperty('--menu-panel-width', (this.panelWidth) + 'px');
      [].forEach.call(this.panel, function (el) {
        el.classList.remove('active');
      });
      this.header.classList.remove('open-menu');
    }
  }
  customElements.define('full-menu', FullMenu);
}